import React from "react";
import { useParams } from "react-router";
import Seo from "../components/seo";
import Layout from "../components/layout";
import SectionNav from "../components/newComponents/sectionNav";
import SectionHead from "../components/newComponents/sectionHead";
import Card from "../components/newComponents/card";
import { useQuery } from "@apollo/client";
import { HandleQuery, WhatWeDoFocusAreasData } from "../queries";

export function WhatWeDoFocusAreasEntry()
{
    const { slug } = useParams();
    const query_state = useQuery(WhatWeDoFocusAreasData(slug), {fetchPolicy: 'no-cache'});
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data; 

    return (
  <Layout>
    <Seo title={data.entry[0].title} />
    <div className="main">
      <SectionNav data={data} base={`/what-we-do/${slug}`} currentUri={`/what-we-do/${slug}/focus-areas`} />
      <section className="section-overview" style={{paddingBottom: 0}}>
          <div className="shell">
          <SectionHead title={data.entry[0].title} subtitle={"Related focus areas"}/>
            </div>
        </section>
      <section className="section-listing section-listing--secondary js-section-listing" style={{paddingTop: 0}}>
        <div className="shell">
          
          <div className="boxes swiper-container js-slider-boxes-projects">
            <ul>
              {data.entry[0].relatedFocusArea.length > 0 ?
                data.entry[0].relatedFocusArea.map((focusArea, i) => (
                  <Card key={`what-we-do-focus-areas-${i}`} image={focusArea.featureImage[0]} title={focusArea.displayTitle} subtitle={focusArea.summary} href={`/${focusArea.uri}`} color={2}/>
                ))
                :
                <li className="box">No content found.</li>
              }
            </ul>
          </div>
        </div>
      </section>
    </div>
  </Layout> 
);
}
